import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { isEmpty } from '@helpers/utils';

type Product = NonNullable<
  GetCatalogProductViewQuery['productDetailByCatalogMasterId']
>;

interface IGetDescriptionIndex {
  description: string;
  composition: Product['features']['composition'];
  variant: Product['variants'][number];
}
export const getDescriptionIndex = ({
  description,
  composition,
  variant,
}: IGetDescriptionIndex) => {
  if (
    !isEmpty(description) ||
    (composition?.length ?? 0) > 0 ||
    variant.characteristics.length > 0
  ) {
    return 'prodDescriptionTabName';
  }
  return '';
};
